import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-badge",
  "use": "icon-badge-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-badge\"><defs><style></style></defs><path d=\"M512 64.304c-133.151 0-288.98 73.68-288.98 73.68v821.711L512 670.685l288.978 289.01v-821.71S656.506 64.304 512 64.304zM649.133 593.8l-137.135-72.07-137.135 72.07 26.199-152.708-110.936-108.114 153.305-22.28 68.567-138.929 68.567 138.928 153.306 22.28-110.937 108.114L649.134 593.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/badge.svg
// module id = 52Ne
// module chunks = 9